import { Component } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService, NotificationsService,
    PriceService
} from '@varsity/services';
import { BaseComponent } from '@varsity/components';
import { PopoverController, ToastController, NavParams, ViewController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the DisplayMessageComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'display-message',
    templateUrl: 'display-message.html'
})
export class DisplayMessageComponent extends BaseComponent {

    header: string;
    icon: string;
    content: string[];
    buttons: { text: string, tag: string }[];
    footer: string;

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected viewCtrl: ViewController,
        protected navParams: NavParams,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "DisplayMessageComponent"
        );
    }

    ngOnInit() {
        let params = this.navParams.get('params') as DisplayMessageParams;

        this.icon = params.icon;
        this.header = params.header;
        this.content = params.content;
        this.buttons = params.buttons;
        this.footer = params.footer;
    }

    buttonClicked(button: { text: string, tag: string }) {
        this.viewCtrl.dismiss({
            button
        });
    }
}

export class DisplayMessageParams {
    icon: string;
    header: string;
    content: string[];
    buttons: { text: string, tag: string }[];
    footer: string;
}


export class ToasterConfig {
    cssClass?: string;
    showCloseButton?: boolean;
    closeButtonText?: string;
    dismissOnPageChange?: boolean;
    position?: string;
    iconName?: string;
}



// WEBPACK FOOTER //
// ./src/components/display-message/display-message.ts